<template>
  <div class="show-more">
    <spinner :show="showSpinner" class="spinner-component"></spinner>
    <p v-if="hasNextPage && !showSpinner">{{ $t('showMore') }}<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span></p>
  </div>
</template>

<script>
  import Spinner from './Spinner.vue'
  export default {
    name: 'show-more',
    components: { Spinner },
    props: ['showSpinner', 'hasNextPage'],
    locales: {
      zh: {
        showMore: '查看更多'
      },
      en: {
        showMore: 'show more'
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../assets/scss/variables";
  * {
    padding: 0;
    margin: 0;
  }
  .show-more {
    text-align: center;
    color: $base-blue;
    cursor: pointer;
  }
  p {
    line-height: .64rem;
    height: .64rem;
  }
  .spinner-component {
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// ShowMore.vue?988cccfe